"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LABEL_ID = exports.TOP_NAV_HEIGHT = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _VisuallyHidden = _interopRequireDefault(require("@match/react-component-library/components/VisuallyHidden"));

var _theming = _interopRequireDefault(require("../../utils/theming"));

var _messages = require("../../constants/messages");

var TOP_NAV_HEIGHT = 56;
exports.TOP_NAV_HEIGHT = TOP_NAV_HEIGHT;
var LABEL_ID = 'mainNavElement';
exports.LABEL_ID = LABEL_ID;

function Banner(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
  return _react.default.createElement(Nav, (0, _extends2.default)({}, props, {
    "aria-labelledby": LABEL_ID
  }), _react.default.createElement(_VisuallyHidden.default, {
    id: LABEL_ID
  }, _react.default.createElement(_reactIntl.FormattedMessage, {
    id: _messages.MESSAGE_ID.MAIN_NAVIGATION
  })), children);
}

var Nav = (0, _theming.default)('nav')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    backgroundColor: theme.palette.core1_100,
    display: 'flex',
    height: "".concat(TOP_NAV_HEIGHT, "px"),
    justifyContent: 'center',
    minWidth: '100%',
    maxWidth: '100%',
    position: 'fixed',
    zIndex: theme.zIndex.nav,
    fontFamily: theme.font.body,
    textRendering: 'optimizeLegibility',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
  };
});
var _default = Banner;
exports.default = _default;